export default __webpack_public_path__ + "static/media/PR Logo With white BG.png.ef6412fe.png";